import { render, staticRenderFns } from "./WelcomeStep.vue?vue&type=template&id=3896898c&scoped=true"
import script from "./WelcomeStep.vue?vue&type=script&lang=js"
export * from "./WelcomeStep.vue?vue&type=script&lang=js"
import style0 from "./WelcomeStep.vue?vue&type=style&index=0&id=3896898c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896898c",
  null
  
)

export default component.exports